import axios from 'axios'
import Cookie from 'js-cookie';

const api = axios.create({
    baseURL: 'https://api.linearpaineis.com.br/api',
    headers: { 'content-type': 'application/json', 'Accept': 'application/json'  },
});


export default api;